import { ENTITY_TYPES, MPARTICLE_EVENTS } from 'constants/analytics';
import type { BuildErrorKey, UploadMethod } from 'containers/MenuUpload/types';
import { logEvent } from 'helpers/mparticle';
import { onboardingStepFor } from 'helpers/onboardingStep';

export type MenuUploadErrorType =
  'build_in_progress' | 'rate_limited' | 'invalid_request' | 'file_upload_failed' | 'submit_failed';

export function trackMenuUploadMethodSelected(params: { method: UploadMethod }): void {
  logEvent(MPARTICLE_EVENTS.selectX, {
    name: `menu_upload_${params.method}`,
    source: 'menu_builder_upload',
  });
}

export function trackMenuUploadSubmitted(params: { method: UploadMethod; source?: string }): void {
  logEvent(MPARTICLE_EVENTS.entityAction, {
    action: 'upload_submitted',
    entity_type: ENTITY_TYPES.menu,
    method: params.method,
    source: params.source,
    ...onboardingStepFor(params.source),
  });
}

export function trackMenuUploadSubmitFailed(params: {
  method: UploadMethod;
  errorType: MenuUploadErrorType;
  source?: string;
}): void {
  logEvent(MPARTICLE_EVENTS.contentSaved, {
    content_type: 'menu_upload',
    error_type: params.errorType,
    method: params.method,
    outcome: 'failed',
    source: params.source,
    ...onboardingStepFor(params.source),
  });
}

export function trackMenuBuildCompleted(params: {
  outcome: 'success' | 'failed';
  errorKey?: BuildErrorKey | null;
  jobId: string;
  source?: string;
}): void {
  logEvent(MPARTICLE_EVENTS.contentSaved, {
    content_type: 'menu_build',
    job_id: params.jobId,
    outcome: params.outcome,
    source: params.source,
    ...onboardingStepFor(params.source),
    ...(params.outcome === 'failed' && { error_type: params.errorKey ?? 'processing_failed' }),
  });
}
